module.exports = __webpack_public_path__ + "8eb9d0b4243be54e0d91ed1f44ce2b38.fbx";